import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { ROUTES } from '../data/stjSite';

/**
 * Reserved advertising slot placeholder - small and compact (like the legacy
 * ~225x150 banner ads), never a stretched full-width bar.
 *
 * This is intentionally simple for now - a real "ad placement" component
 * (rotating admin-managed images/links, click tracking, per-page targeting)
 * is planned as a follow-up. Every call site is already wired with a stable
 * `id` so that future component can slot straight in without any layout
 * changes.
 */
const AdSlot = ({ id, className = 'w-36 sm:w-40 aspect-[3/2]' }) => (
  <Link
    to={ROUTES.contactUs}
    className={`group flex shrink-0 flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-red-200 bg-red-50/50 p-2 text-center transition-colors hover:border-red-400 hover:bg-red-50 ${className}`}
    data-testid={`ad-slot-${id}`}
    aria-label="Advertise here"
  >
    <Megaphone className="h-4 w-4 text-red-400 transition-colors group-hover:text-red-600" />
    <span className="text-[10px] font-bold uppercase tracking-wide text-red-600">Advertise Here</span>
  </Link>
);

export default AdSlot;
